import { useMemo, useCallback } from 'react';
import { atom } from 'jotai';
import { atomWithStorage, useUpdateAtom, useAtomValue } from 'jotai/utils';

export const skipToursAtom = atomWithStorage<Record<string, boolean>>('skipTours', {});

export const useSkipTours = (key: string) => {
  const setSkipTours = useUpdateAtom(skipToursAtom);
  const addSkipTour = useCallback(() => {
    setSkipTours((prev) => ({ ...prev, [key]: true }));
  }, [setSkipTours, key]);
  const anAtom = useMemo(() => atom((get) => !!get(skipToursAtom)[key]), [key]);
  const value = useAtomValue(anAtom);
  return [value, addSkipTour] as [boolean, () => void];
};
